import { render, staticRenderFns } from "./TeacherRecruitInfo.vue?vue&type=template&id=d4bdbd8e&scoped=true"
import script from "./TeacherRecruitInfo.vue?vue&type=script&lang=js"
export * from "./TeacherRecruitInfo.vue?vue&type=script&lang=js"
import style0 from "./TeacherRecruitInfo.vue?vue&type=style&index=0&id=d4bdbd8e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4bdbd8e",
  null
  
)

export default component.exports